import styled from 'styled-components';

import {
    Card,
    IconChevronRightCircle,
    Image,
    token,
} from '@zillow/constellation';

export const StyledCard = styled(Card)`
    min-height: 150px;
    cursor: pointer;
`;

export const StyledIconChevronRightCircle = styled(IconChevronRightCircle)`
    color: ${token('colors.brand')};
    float: right;
    position: relative;
    bottom: 4px;
`;

export const StyledImageForSvg = styled(Image)`
    position: relative;
    bottom: 10px;
`;
